import type {SeedQuestion} from '@cp/model';
import {doc, getDoc} from 'firebase/firestore';
import {COLLECTION_EXAM_MODULE} from '@cp/model';
import {firebaseFirestore} from '../../config/firebase';
import mapSeedQuestionDoc from './mapSeedQuestionDoc';

const SUBCOLLECTION_SEED_QUESTION = 'seedQuestions';

export default async function getSeedQuestionDoc(moduleId: string, seedQuestionId: string): Promise<SeedQuestion> {
  const ref = doc(firebaseFirestore, COLLECTION_EXAM_MODULE, moduleId, SUBCOLLECTION_SEED_QUESTION, seedQuestionId);
  const snap = await getDoc(ref);
  if (!snap.exists()) {
    throw new Error('Seed question not found');
  }
  const mapped = mapSeedQuestionDoc(snap);
  if (!mapped) {
    throw new Error('Seed question data invalid');
  }
  return mapped;
}
